// BUGS.md T14 (module 10 U338; migration 264). A triage card's "today" and "tomorrow" are the person's own day, and Cobrain learns
// which day that is from the person: Mike, 8 Oct 2026, "you need to understand from the user what time zone there are in". So the
// portal says, once a page load, the zone its browser runs in, and the server keeps it on their own profile in each store, where the
// passes that rank without a browser read it too. Nothing is drawn: a zone not kept leaves the page as it was.
import { api } from './api.js';

let sent = false;

/** The zone `Intl` says this browser is on ("Europe/Paris"), or null where it says none. */
export function browserZone(): string | null {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof zone === 'string' && zone.length > 0 ? zone : null;
  } catch {
    return null;
  }
}

/** Once a page load, after sign-in. */
export function reportZone(): void {
  if (sent) return;
  const zone = browserZone();
  if (!zone) return;
  sent = true;
  try {
    void Promise.resolve(api.zone(zone)).catch(() => { sent = false; });
  } catch {
    sent = false;   // a stand-in api without the call, or one that throws: the page never pays for the report
  }
}
